export enum ExpressionType {
  JSONATA = 'jsonata',
}

export enum DataSourceType {
  COMMENDA_LOGICAL_BACKEND = 'commenda_logical_backend',
}

export enum FieldRefSource {
  CONTEXT = 'context',
  STEP = 'step',
  DATASOURCE = 'datasource',
  EACH = 'each',
}

export enum IterableType {
  EXPRESSION = 'expression',
  STEP = 'step',
  DATASOURCE = 'datasource',
}

// SYS_API_CALL Enums

export enum ApiCallHttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

